import { useEffect, useState } from 'react';
import { LoadingIndicator } from '../LoadingIndicator';
import { Box, Checkbox } from '@mui/material';
import COLORS from '../../colors';
import styled from 'styled-components';

const Headline = styled.div`
  font-size: 16px;
  line-height: 24px;
  color: ${COLORS.NAV_ACTIVE};
  text-align: center;
`;

const StyledElementContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  font-size: 13.33px;
`;

const StyledContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px 16px 0px;
  gap: 4px;
`;

const StyledBox = styled(Box)<StyledBoxProps>`
  border-radius: 12px;
  background-color: ${(props) =>
    props.checked ? COLORS.CHECKED : COLORS.NEUTRAL_900};
  width: 90px;
  height: 130px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  cursor: pointer;
`;

interface StyledBoxProps {
  checked: boolean;
}

interface VerticalListItemProps {
  title: string;
  onClick: (checked: boolean) => void;
  isChecked: boolean;
  loadingPercentage: number;
}

const VerticalListItem = ({
  title,
  onClick,
  isChecked,
  loadingPercentage
}: VerticalListItemProps) => {
  const handleClick = (): void => {
    onClick(!isChecked);
  };

  return (
    <StyledBox checked={isChecked} onClick={handleClick}>
      <StyledContentContainer>
        <Headline>{title}</Headline>
        <StyledElementContainer>
          <LoadingIndicator loadingPercentage={loadingPercentage} />
          <Checkbox
            checked={isChecked}
            sx={{
              color: COLORS.NEUTRAL_200
            }}
          />
        </StyledElementContainer>
      </StyledContentContainer>
    </StyledBox>
  );
};

export default VerticalListItem;
